import React, { useEffect } from "react";
import QlikCard from "shared/components/QlikCard";
import QlikObject from "shared/components/QlikObject";

export default function ProcedureType({ title, pageTitle }) {
  useEffect(() => {
    document.title = `${pageTitle} - ${title}`;
  }, [pageTitle,title]);
  return (
    <section className="content">
      <div className="content-header">
        <div className="row mb-2">
          <div className="col-md-10 col-sm-9 col-10">
            <h5 className="page-title"> {title} </h5>
          </div>
           <div className="col-md-2 col-sm-3 col-2">
            <QlikObject id="PchSNG" height="35px" showLoader={false} />
          </div> 
        </div>
      </div>

      <div className="container-fluid">
        <div className="row justify-content-start">
          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <QlikCard
              id="KZWPv"
              height="56px"
              showHeader={false}
              showMaximize={false}
              showExport={false}
            />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <QlikCard
              id="jbnFj"
              height="56px"
              showHeader={false}
              showMaximize={false}
              showExport={false}
            />
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-12">
            {/* vizTable */}
            <QlikCard
              id="ePrfQp"
              height="370px"
              showLoader={true}
              showExport={false}
              showHeader={true}
            />
          </div>
          <div className="col-12">
            {/* vizTable */}
            <QlikCard
              id="JmwYJp"
              height="300px"
              showLoader={true}
              showExport={false}
              showHeader={true}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
